import { gql } from '@apollo/client';
import { Box, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { TableInstance } from 'react-table';
import { FlattenedNotificationRow } from './useEmailNotification';

interface Props {
  table: TableInstance<FlattenedNotificationRow>;
}

export function EmailNotificationTable({ table }: Props) {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = table;

  return (
    <Table {...getTableProps()} variant="simple" width="100%" layout="fixed">
      <Thead>
        {headerGroups.map((headerGroup) => {
          const headerGroupProps = headerGroup.getHeaderGroupProps();

          return (
            <Tr {...headerGroupProps} key={headerGroupProps.key}>
              {headerGroup.headers.map((column) => {
                const headerProps = column.getHeaderProps();

                return (
                  <Th
                    {...headerProps}
                    key={headerProps.key}
                    color={'gray.600'}
                    minWidth={`${column.minWidth}px`}
                    maxWidth={`${column.maxWidth}px`}
                    width={column.width}
                  >
                    <Box display="inline-flex" flexDirection="row" alignItems="center">
                      <Box flex="1" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                        {column.render('Header')}
                      </Box>
                    </Box>
                  </Th>
                );
              })}
            </Tr>
          );
        })}
      </Thead>
      <Tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          const rowProps = row.getRowProps();

          return (
            <Tr {...rowProps} key={rowProps.key}>
              {row.cells.map((cell) => {
                const cellProps = cell.getCellProps();
                return (
                  <Td
                    {...cellProps}
                    key={cellProps.key}
                    minWidth={`${cell.column.minWidth}px`}
                    maxWidth={`${cell.column.maxWidth}px`}
                    width={cell.column.width}
                  >
                    {cell.render('Cell')}
                  </Td>
                );
              })}
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}

EmailNotificationTable.graphql = {
  fragments: {
    EmailNotificationTable: gql`
      fragment EmailNotificationTable on NotificationSettingsModel {
        id
        settings {
          status
          alertType
          reminderType
          notificationType
        }
      }
    `,
  },
};
